import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the GoalsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class DirectDebitProvider {

  constructor(public gateway: GatewayClientProvider) {

  }

  getAllDebitList(bycustomers_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getAllRegularSavings(bycustomers_id)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    })
  }
  getDebitlist(byaccountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getDirectDebits(byaccountno)
        .then((data) => {
          resolve(data);
        }).catch((error) => {
          reject(error);
        })
    });
  }
  addDirectDebit(dd) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addDirectDebit(dd)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }
  updateDirectDebit(dd) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateDirectDebit(dd)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }
  removeDirectDebit(cancel) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.removeDirectDebit(cancel)
        .then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        })
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/direct-debit/direct-debit.ts